export default __webpack_public_path__ + "static/media/success.877caa9f.svg";